var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center h-full" },
    [
      _vm._l(_vm.sortedItems, function (item, i) {
        return _c(
          "span",
          { key: i, staticClass: "chip-wrapper" },
          [
            _vm.clickable
              ? [
                  _c(
                    "span",
                    { staticClass: "chip" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: `${_vm.path}/${item.id}` } },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ],
                    1
                  ),
                ]
              : [
                  _c("span", { staticClass: "chip" }, [
                    _vm._v(" " + _vm._s(item.name)),
                  ]),
                ],
          ],
          2
        )
      }),
      _c("span", { staticClass: "chip-wrapper" }, [
        _vm.itemsMoreThanLimit
          ? _c(
              "span",
              {
                staticClass:
                  "my-auto text-gray-800 inline-block border-2 border-transparent rounded-full font-medium text-gray-700 truncate py-0.5 px-2 mx-0.5 transition duration-150 ease-in-out w-full",
              },
              [_vm._v("+ " + _vm._s(_vm.items.length - _vm.limit))]
            )
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }